import { actionCreator } from '@/utils/redux';

import {
  ApplicationType,
  FeatureFlags,
  GlobalIdentifiedNotification,
  GlobalNotification,
  NAMESPACE,
  Partner,
} from './types';

const creator = actionCreator(NAMESPACE);

export type AddNotificationActionPayload = GlobalNotification & { timeout?: number | 'infinite' };

export type RemoveNotificationActionPayload = { id?: string; type?: string };
export type StoreAddNotificationActionPayload = GlobalIdentifiedNotification;
export type StoreLoadingActionPayload = { loading: boolean; messageId?: string };
export type StoreLocaleActionPayload = { locale: string };
export type StoreAppTypeActionPayload = { type: ApplicationType };
export type StoreTogglePayload = { flags: Partial<Record<FeatureFlags, boolean>>; error?: string };
export type StoreInitActionPayload = { partner?: Partner };
export type StoreFrameModeActionPayload = { isFrame: boolean };
export type StoreViewModeActionPayload = { isMobile?: boolean; vh?: number };

// for components
export const init = creator.asyncAction<void>('INIT');
export const initAppType = creator.asyncAction<void>('INIT_APP');
export const initLocale = creator.asyncAction<void>('INIT_LOCALE');
export const initFrame = creator.asyncAction<void>('INIT_FRAME');
export const addNotification = creator.asyncActionWithPayload<AddNotificationActionPayload, void>('ADD_NOTIFICATION');
export const requestToggle = creator.asyncAction<void>('REQUEST_TOGGLE');
export const logout = creator.asyncAction<void>('LOGOUT');

// internal
export const storeLoading = creator.syncActionWithPayload<StoreLoadingActionPayload>('STORE_LOADING');
export const storeSaveNotification = creator.syncActionWithPayload<StoreAddNotificationActionPayload>(
  'STORE_SAVE_NOTIFICATION',
);
export const storeRemoveNotification = creator.syncActionWithPayload<RemoveNotificationActionPayload>(
  'STORE_REMOVE_NOTIFICATION',
);
export const storeLocale = creator.syncActionWithPayload<StoreLocaleActionPayload>('STORE_LOCALE');
export const storeAppType = creator.syncActionWithPayload<StoreAppTypeActionPayload>('STORE_APP');
export const storeToggle = creator.syncActionWithPayload<StoreTogglePayload>('STORE_TOGGLE');
export const storeInitializationState = creator.syncActionWithPayload<StoreInitActionPayload>('STORE_INITIALIZATION');
export const storeFrameMode = creator.syncActionWithPayload<StoreFrameModeActionPayload>('STORE_FRAME_MODE');
export const storeViewMode = creator.syncActionWithPayload<StoreViewModeActionPayload>('STORE_VIEW_MODE');
export const storeLogout = creator.syncAction('STORE_LOGOUT');

// notification
export const notifyGlobalInitializationStarted = creator.asyncAction('NOTIFY_INIT_STARTED');
export const notifyLogout = creator.syncAction('NOTIFY_LOGOUT');

export default {
  addNotification,
  init,
  initAppType,
  initFrame,
  initLocale,
  requestToggle,
  logout,
  storeAppType,
  storeLoading,
  storeLocale,
  storeLogout,
  storeFrameMode,
  storeViewMode,
  storeSaveNotification,
  storeRemoveNotification,
  notifyGlobalInitializationStarted,
  notifyLogout,
};
